import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate and useLocation
import ilodrop from "../../assets/icons/ilodrop.svg";
import ilosearch from "../../assets/icons/ilosearch.svg";
import ilocross from "../../assets/icons/ilocross.svg";
import dataIcon from "../../assets/icons/compData.svg";
import gradIcon from "../../assets/icons/compGrad.svg";
import editorialIcon from "../../assets/icons/compEdit.svg";
import partnerIcon from "../../assets/icons/compPartner.svg";
import documentIcon from "../../assets/icons/comDoc.svg";
import Citation from "../../components/Citation";
import { fetchPartySuggestions } from "../../service/partyname";
import { fetchLegislationTitleSuggestions, fetchLegislationProvisionSuggestions } from "../../service/byAct";
import { fetchContractKeywordSuggestions } from "../../service/contracts";
// import axios from "axios";
import "./Landing.scss";

function LandingPage() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [activeTab, setActiveTab] = useState("Caselaw");
  const [petitionerTab, setPetitionerTab] = useState("Any");
  const [authError, setAuthError] = useState("");
  const [legislationAuthError, setLegislationAuthError] = useState("");
  const [showBottomRunningLine, setShowBottomRunningLine] = useState(false);
  const [query, setQuery] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [progress, setProgress] = useState(100);

  // added state for Act / Provision inputs
  const [actTitle, setActTitle] = useState("");
  const [actProvision, setActProvision] = useState("");
  const [citationData, setCitationData] = useState(null);

  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFromDropdown, setSelectedFromDropdown] = useState(false);

  const navigate = useNavigate(); // Initialize useNavigate
  const location = useLocation(); // Initialize useLocation
  const dropdownRef = useRef(null);

  const [legislationTitleSuggestions, setLegislationTitleSuggestions] = useState([]);
  const [isLoadingLegislationTitle, setIsLoadingLegislationTitle] = useState(false);
  const [showLegislationTitleDropdown, setShowLegislationTitleDropdown] = useState(false);
  const [selectedLegislationTitle, setSelectedLegislationTitle] = useState(false);
  const legislationTitleRef = useRef(null);

  const [legislationProvisionSuggestions, setLegislationProvisionSuggestions] = useState([]);
  const [isLoadingLegislationProvision, setIsLoadingLegislationProvision] = useState(false);
  const [showLegislationProvisionDropdown, setShowLegislationProvisionDropdown] = useState(false);
  const [selectedLegislationProvision, setSelectedLegislationProvision] = useState(false);
  const legislationProvisionRef = useRef(null);

  const [contractKeyword, setContractKeyword] = useState("");
  const [contractKeywordSuggestions, setContractKeywordSuggestions] = useState([]);
  const [isLoadingContractKeyword, setIsLoadingContractKeyword] = useState(false);
  const [showContractKeywordDropdown, setShowContractKeywordDropdown] = useState(false);
  const [selectedFromDealbaseDropdown, setSelectedFromDealbaseDropdown] = useState(false);
  const dropdownDealbaseRef = useRef(null);
  const searchInputRef = useRef(null);
  const [activeFeatureModal, setActiveFeatureModal] = useState(null);

  const userId = localStorage.getItem("user_id");
  const isLoggedIn = userId && userId !== "null" && userId !== "undefined";

  const tabs = ["Caselaw", "Legislation", "Contracts"];

  const dropdownOptions = {
    Caselaw: ["Keyword", "Party Name", "Citation", "Act / Provision"],
    Legislation: ["All", "Center", "State"],
    Contracts: ["Contracts", "Clauses", "Definitions"],
  };

  const popularSearches = {
    Caselaw: ["Kesavananda Bharati", "Right to Privacy", "Section 302 IPC", "Article 21"],
    Legislation: ["Constitution of India", "Companies Act 2013", "Bharatiya Nyaya Sanhita", "IT Act 2000"],
    Contracts: ["Non-Disclosure Agreement", "Indemnity Clause", "Termination for Cause", "Governing Law"],
  };

  const featureDetails = {
    databases: {
      title: "Comprehensive Databases",
      icon: dataIcon,
      subtitle: "Knowledge graphs + editorial curation",
      details: "Explore over 500,000+ judgments, 2,500+ statutes, and legal contracts structured with AI knowledge graphs and expert human verification for rapid legal research.",
      highlights: ["Cross-referenced Citations", "Deep Headnote Metadata", "Real-time Legislation Status"]
    },
    excellence: {
      title: "Research Excellence",
      icon: gradIcon,
      subtitle: "Trusted by universities & labs",
      details: "Engineered in partnership with leading legal scholars and law schools to provide high-precision semantic search and natural language querying across centuries of jurisprudence.",
      highlights: ["AI Semantic Search", "Relevance Scoring", "Vector Search Technology"]
    },
    partnerships: {
      title: "Institutional Partnerships",
      icon: partnerIcon,
      subtitle: "Collabs with think tanks",
      details: "Integrating specialized insights from top legal think tanks, policy centers, and institutional repositories for comprehensive comparative legal analysis.",
      highlights: ["Policy Papers & Insights", "Global Comparative Law", "Verified Academic Sources"]
    },
    digests: {
      title: "Editorial Digests",
      icon: editorialIcon,
      subtitle: "Concise headnotes, same-day updates",
      details: "Daily curated headnotes and instant digest overviews published within hours of court pronouncements by senior legal editors.",
      highlights: ["Same-Day Supreme Court Updates", "Point of Law Extraction", "Key Overruling Alerts"]
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handlePopularSearchClick = (term) => {
    if (activeTab === "Contracts") {
      setContractKeyword(term);
    } else if (activeTab === "Caselaw" && dropdownValue === "Act / Provision") {
      setActTitle(term);
    } else {
      setQuery(term);
    }
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  // useEffect(() => {
  //   console.log("Active Tab changed to:", activeTab);
  // }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "Contracts") return;

    const activeData = {
      contractType: dropdownValue === "Contracts",
      clause: dropdownValue === "Clauses",
      definition: dropdownValue === "Definitions",
    };

    localStorage.setItem("activeTab", JSON.stringify(activeData));
  }, [dropdownValue, activeTab]);

  useEffect(() => {
    // Reset all state values when the component mounts or when location changes
    setDropdownValue(dropdownOptions[activeTab][0]);
    setQuery("");
    setActTitle("");
    setActProvision("");
    setCitationData(null);
    setPetitionerTab("Any");
    setDropdownOpen(false);
  }, [activeTab, location.key]); // location.key changes on navigation

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Function to handle the party search logic
  const handlePartySearch = () => {
    if (!query) {
      console.log("No query provided for Party search.");
      return;
    }

    // Construct payload as URL query params
    const queryParams = new URLSearchParams({
      search_text: query,
      search_type: petitionerTab, // send selected petitionerTab as search_type
      tab: activeTab,
      dropdown: dropdownValue,
      petitioner: petitionerTab,
      searchMode: "party",
    }).toString();

    // Navigate to the party search result route with query params
    navigate(`/casebase/casebase-result/Word-Search?${queryParams}`);
  };

  // Function to handle the Act / Provision search
  const handleActProvisionSearch = () => {
    let searchMode;
    // require at least one of title or provision
    if (!actTitle && !actProvision) {
      console.log("Enter legislation title or provision.");
      return;
    }
    searchMode = "act";

    const payload = {
      title: actTitle,
      provision: actProvision,
    };

    const queryParams = new URLSearchParams({
      // payload: JSON.stringify(payload),
      title: actTitle,
      provision: actProvision,
      // tab: activeTab,
      // dropdown: dropdownValue,
      searchMode
    }).toString();

    navigate(`/casebase/casebase-result/Word-Search?${queryParams}`);
  };

  useEffect(() => {
    console.log("Citation Data", citationData)
  }, [citationData])

  // Function to handle the search logic
  const handleSearch = () => {
    if (!isLoggedIn) {
      setShowLoginPopup(true);
      setProgress(100);

      // animate progress bar over 10 seconds
      let width = 100;
      const interval = setInterval(() => {
        width -= 1;
        setProgress(width);
        if (width <= 0) clearInterval(interval);
      }, 100); // 100ms * 100 = 10 seconds

      // hide popup after 10 sec
      setTimeout(() => setShowLoginPopup(false), 10000);
      return;
    }
    let searchMode;

    if (activeTab === "Caselaw" && dropdownValue === "Keyword") {
      searchMode = "word";
      console.log("Searching Caselaw by Keyword:", query);

      const queryParams = new URLSearchParams({
        search_text: query,
        search_type: "all",
        // tab: activeTab,
        // dropdown: dropdownValue,
        petitioner: petitionerTab,
        searchMode,
      }).toString();

      navigate(`/casebase/casebase-result/Word-Search?${queryParams}`);
    } else if (activeTab === "Caselaw" && dropdownValue === "Party Name") {
      handlePartySearch();
    } else if (activeTab === "Caselaw" && dropdownValue === "Act / Provision") {
      handleActProvisionSearch();
    } else if (activeTab === "Caselaw" && dropdownValue === "Citation") {
      // citation branch
      if (!citationData) {
        console.log("Enter citation details.");
        return;
      }

      let paramsObj = {};

      if (citationData.activeCitation === "By Publisher") {
        paramsObj = {
          mode: "publisher",
          year: citationData.pubYear || "",
          publisher: citationData.publisherValue || "",
          volNo: citationData.volumeValue || "",
          pageNo: citationData.pageValue || "",
          searchMode: "publisher"
        };
      } else if (citationData.activeCitation === "By Neutral Citation") {
        paramsObj = {
          mode: "nuetral",
          year: citationData.ncYear || "",
          court: citationData.courtName || "",
          nc_abvr: citationData.citationAbbr || "",
          pageNo: citationData.citationPage || "",
          searchMode: "nuetral"
        };
      }
      const params = new URLSearchParams(paramsObj).toString();
      // use full page navigation so the casebase citation page (possibly a micro-frontend) loads correctly
      window.location.href = `/casebase/casebase-result/FindByCitation?${params}`;
    } else if (activeTab === "Legislation") {
      if (!query) {
        console.log("Enter query for Legislation search.");
        return;
      }
      // send the typed query as `query` to the specified route
      // use full page navigation so the lawbase micro-frontend loads correctly
      const params = new URLSearchParams({ query }).toString();
      window.location.href = `/lawbase/quicksearch-result/all-search?${params}`;
    } else if (activeTab === "Contracts") {
      const token = localStorage.getItem('token');
      if (!token) return;
      if (!contractKeyword.trim()) {
        console.log("Enter query for Contracts search.");
        return;
      }

      const encodedKeyword = encodeURIComponent(contractKeyword.trim());
      window.location.href = `/contractdb/search-result/${encodedKeyword}`;
    } else {
      console.log("Search for other tabs/dropdowns is not implemented yet.");
      return;
    }
  };

  // Fetch suggestions only if dropdownValue is "Party Name" and not selected
  useEffect(() => {
    if (
      activeTab !== "Caselaw" ||
      dropdownValue !== "Party Name" ||
      selectedFromDropdown
    ) {
      return;
    }

    if (!query.trim()) {
      setSuggestions([]);
      setIsLoading(false);
      return;
    }

    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchPartySuggestions(query, petitionerTab, signal);
        setSuggestions(data || []);
      } catch (err) {
        // if (axios.isCancel(err)) return;
        console.error("Error fetching suggestions:", err);
        setSuggestions([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

    return () => controller.abort();
  }, [query, activeTab, dropdownValue, selectedFromDropdown]);

  const handleInputChange = (value) => {
    setQuery(value);
    setSelectedFromDropdown(false); // reset flag if user edits input manually
  };

  const handleSelectSuggestion = (value) => {
    setQuery(value);
    setSelectedFromDropdown(true); // prevents further API calls
    setSuggestions([]); // close dropdown
  };

  // Legislation Title
  useEffect(() => {
    if (selectedLegislationTitle) return;

    const fetchSuggestions = async () => {
      const trimmed = actTitle.trim();
      if (!trimmed) {
        setLegislationTitleSuggestions([]);
        setShowLegislationTitleDropdown(false);
        return;
      }

      setIsLoadingLegislationTitle(true);
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const data = await fetchLegislationTitleSuggestions(trimmed);
        setLegislationTitleSuggestions(data);
        setShowLegislationTitleDropdown(true);
      } catch (err) {
        console.error("Error fetching legislation title suggestions:", err);
      } finally {
        setIsLoadingLegislationTitle(false);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [actTitle, selectedLegislationTitle]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (legislationTitleRef.current && !legislationTitleRef.current.contains(e.target)) {
        setShowLegislationTitleDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectLegislationTitle = (value) => {
    setActTitle(value);
    setSelectedLegislationTitle(true);
    setShowLegislationTitleDropdown(false);
  };

  const handleChange = (e) => {
    setActTitle(e.target.value);
    setSelectedLegislationTitle(false);
  };

  // Provision
  useEffect(() => {
    if (selectedLegislationProvision) return;

    const fetchSuggestions = async () => {
      const trimmed = actProvision.trim();
      if (!trimmed || !actTitle) {
        setLegislationProvisionSuggestions([]);
        setShowLegislationProvisionDropdown(false);
        return;
      }

      setIsLoadingLegislationProvision(true);
      try {
        const data = await fetchLegislationProvisionSuggestions(trimmed, actTitle);
        setLegislationProvisionSuggestions(data);
        setShowLegislationProvisionDropdown(true);
      } catch (err) {
        console.error("Error fetching legislation provision suggestions:", err);
      } finally {
        setIsLoadingLegislationProvision(false);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [actProvision, actTitle, selectedLegislationProvision]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (legislationProvisionRef.current && !legislationProvisionRef.current.contains(e.target)) {
        setShowLegislationProvisionDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectProvision = (value) => {
    setActProvision(value);
    setSelectedLegislationProvision(true);
    setShowLegislationProvisionDropdown(false);
  };

  const handleChangeProvision = (e) => {
    setActProvision(e.target.value);
    setSelectedLegislationProvision(false);
  };

  // Dealbase
  useEffect(() => {
    if (selectedFromDealbaseDropdown) return;

    const fetchSuggestions = async () => {
      const trimmed = contractKeyword.trim();
      setAuthError(""); // reset each time

      if (!trimmed) {
        setContractKeywordSuggestions([]);
        setShowContractKeywordDropdown(false);
        return;
      }

      const token = localStorage.getItem('token');

      if (!token) {
        setAuthError("Please Login First");
        setShowContractKeywordDropdown(true);
        setContractKeywordSuggestions([]);
        return;
      }

      setIsLoadingContractKeyword(true);
      try {
        const data = await fetchContractKeywordSuggestions(trimmed, userId);
        setContractKeywordSuggestions(data?.results || []);
        setShowContractKeywordDropdown(true);
      } catch (err) {
        console.error("Error fetching keyword suggestions:", err);
      } finally {
        setIsLoadingContractKeyword(false);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [contractKeyword, selectedFromDropdown, userId]);

  useEffect(() => {
    console.log("Show Popup true", showLoginPopup);
  }, [showLoginPopup])
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowContractKeywordDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    setContractKeyword(value);
    setSelectedFromDealbaseDropdown(true);
    setShowContractKeywordDropdown(false);
  };

  const handleDealbaseChange = (e) => {
    setContractKeyword(e.target.value);
    setSelectedFromDealbaseDropdown(false);
  };

  return (
    <div className="landing-page">
      <div className="landing-page-hero-glow"></div>
      <div className="landing-page-upper">
        <div className="landing-page-upper-subtitle">
          <img src={documentIcon} alt="Document Icon" />
          <span>UNIFIED LEGAL SEARCH</span>
          <span className="landing-page-badge-pulse"></span>
        </div>
        <div className="landing-page-upper-title">
          One Search. <span className="title-gradient">Infinite Legal Insights</span>
        </div>
        <div className="landing-page-upper-description">
          Search across Case Law, Contracts, and Legislation in one place.
        </div>

        <div className="landing-page-upper-container">
          <div className="landing-page-upper-container-buttons">
            <div className="landing-page-upper-container-buttons-left">
              {tabs.map((tab) => (
                <span
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={
                    activeTab === tab
                      ? "landing-page-upper-container-buttons-left-tab landing-page-upper-container-buttons-left-active"
                      : "landing-page-upper-container-buttons-left-tab"
                  }
                >
                  {tab}
                </span>
              ))}
            </div>
          </div>
          <div className="landing-page-upper-container-field-bottom-container">
            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div className="landing-page-upper-container-field-dropdown">
                <div style={{ position: "relative" }}>
                  <div
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="landing-page-upper-container-buttons-right"
                  >
                    <span>{dropdownValue}</span>
                    <span>
                      <img src={ilodrop} alt="icon" />
                    </span>
                  </div>

                  {dropdownOpen && (
                    <div
                      ref={dropdownRef}
                      className="landing-page-upper-container-dropdown"
                    >
                      {dropdownOptions[activeTab].map((option) => (
                        <span
                          key={option}
                          onClick={() => {
                            setDropdownValue(option);
                            setDropdownOpen(false);
                          }}
                          className="landing-page-upper-container-dropdown-item"
                        >
                          {option}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {activeTab === "Caselaw" &&
                (dropdownValue === "Party Name" || dropdownValue === "Keyword") && (
                  <div className="landing-page-upper-container-field" style={{ position: "relative" }}>
                    {!query && (
                      <span style={{ lineHeight: "10px" }}>
                        <img width="18px" src={ilosearch} alt="search" />
                      </span>
                    )}
                    <input
                      ref={searchInputRef}
                      placeholder={dropdownValue === "Party Name" ? "Enter Party Name" : "Enter Keyword"}
                      value={query}
                      onChange={(e) => handleInputChange(e.target.value)}
                      autoComplete="off"
                    />
                    <span className="keyboard-shortcut-hint"><kbd>⌘K</kbd></span>
                    {query && (
                      <span
                        onClick={() => {
                          setQuery("");
                          setSelectedFromDropdown(false);
                        }}
                        style={{ position: "absolute", right: "50px", cursor: "pointer" }}
                      >
                        <img src={ilocross} alt="clear" />
                      </span>
                    )}

                    {/* Suggestions / Loading */}
                    {query && dropdownValue === "Party Name" && (
                      <>
                        {/* Show loading if suggestions are being fetched or empty */}
                        {isLoading && (
                          <div className="landing-page-suggestions-dropdown-loading">Loading...</div>
                        )}

                        {/* Show dropdown only if there are suggestions */}
                        {!isLoading && suggestions.length > 0 && (
                          <div className="landing-page-suggestions-dropdown">
                            {suggestions.map((item, idx) => (
                              <div
                                key={idx}
                                className="landing-page-suggestions-item"
                                onMouseDown={() => handleSelectSuggestion(item)}
                              >
                                {item}
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}

              {activeTab === "Legislation" &&
                (dropdownValue === "All" ||
                  dropdownValue === "Center" ||
                  dropdownValue === "State") && (
                  <div className="landing-page-upper-container-field" style={{ position: "relative" }}>
                    {!query && (
                      <span style={{ lineHeight: "10px" }}>
                        <img width={"18px"} src={ilosearch} alt="search" />
                      </span>
                    )}
                    <input
                      ref={searchInputRef}
                      placeholder="Type Keywords"
                      onChange={(e) => setQuery(e.target.value)}
                      value={query}
                    />
                    <span className="keyboard-shortcut-hint"><kbd>⌘K</kbd></span>
                    {query && (
                      <span
                        onClick={() => setQuery("")}
                        style={{ position: "absolute", right: "50px" }}
                      >
                        <img src={ilocross} alt="clear" />
                      </span>
                    )}
                  </div>
                )}

              {activeTab === "Contracts" &&
                (dropdownValue === "Contracts" ||
                  dropdownValue === "Clauses" ||
                  dropdownValue === "Definitions") && (
                  <div className="landing-page-upper-container-field" style={{ position: "relative" }}>
                    {!contractKeyword && (
                      <span style={{ lineHeight: "10px" }}>
                        <img width={"18px"} src={ilosearch} alt="search" />
                      </span>
                    )}
                    <div
                      className="landing-page-upper-container-field"
                      style={{ position: "relative" }}
                      ref={dropdownRef}
                    >
                      <input
                        ref={searchInputRef}
                        placeholder="Type Keywords"
                        onChange={handleDealbaseChange}
                        value={contractKeyword}
                        autoComplete="off"
                      />
                      <span className="keyboard-shortcut-hint"><kbd>⌘K</kbd></span>
                      {showContractKeywordDropdown && (
                        <div className="landing-page-suggestions-dropdown">
                          {authError ? (
                            <div className="landing-page-suggestions-empty" style={{ color: "red" }}>
                              {authError}
                            </div>
                          ) : isLoadingContractKeyword ? (
                            <div className="landing-page-suggestions-loading">Loading...</div>
                          ) : contractKeywordSuggestions.length > 0 ? (
                            contractKeywordSuggestions.map((item, idx) => (
                              <div
                                key={idx}
                                className="landing-page-suggestions-item"
                                onMouseDown={() =>
                                  handleSelect(item.contract_title || item.clause_heading || item.define_term)
                                }
                              >
                                <div style={{ textTransform: 'capitalize' }}>
                                  {item.contract_title || item.clause_heading || item.define_term}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="landing-page-suggestions-empty">
                              No suggestions found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {contractKeyword && (
                      <span
                        onClick={() => setContractKeyword("")}
                        style={{ position: "absolute", right: "50px" }}
                      >
                        <img src={ilocross} alt="clear" />
                      </span>
                    )}
                  </div>
                )}

              {activeTab === "Caselaw" &&
                dropdownValue === "Act / Provision" && (
                  <div className="landing-page-upper-container-field-act">
                    <div
                      className="landing-page-upper-container-field-act-title"
                      style={{ position: "relative" }}
                      ref={legislationTitleRef}
                    >
                      <input
                        ref={searchInputRef}
                        placeholder="Enter Legislation Title"
                        value={actTitle}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                      {showLegislationTitleDropdown && (
                        <div style={{ left: "0px", top: "35px" }} className="landing-page-suggestions-dropdown">
                          {isLoadingLegislationTitle ? (
                            <div className="landing-page-suggestions-loading">Loading...</div>
                          ) : legislationTitleSuggestions.length > 0 ? (
                            legislationTitleSuggestions.map((item, idx) => (
                              <div
                                key={idx}
                                className="landing-page-suggestions-item"
                                onMouseDown={() => handleSelectLegislationTitle(item)}
                              >
                                {item}
                              </div>
                            ))
                          ) : (
                            <div className="landing-page-suggestions-empty">No suggestions found</div>
                          )}
                        </div>
                      )}
                    </div>
                    <div
                      className="landing-page-upper-container-field-act-provision"
                      style={{ position: "relative" }}
                      ref={legislationProvisionRef}
                    >
                      <input
                        placeholder="Enter Provision"
                        value={actProvision}
                        onChange={handleChangeProvision}
                        autoComplete="off"
                      />

                      {showLegislationProvisionDropdown && (
                        <div style={{ left: "0px", top: "35px" }} className="landing-page-suggestions-dropdown">
                          {isLoadingLegislationProvision ? (
                            <div className="landing-page-suggestions-loading">Loading...</div>
                          ) : legislationProvisionSuggestions.length > 0 ? (
                            legislationProvisionSuggestions.map((item, idx) => (
                              <div
                                key={idx}
                                className="landing-page-suggestions-item"
                                onMouseDown={() => handleSelectProvision(item)}
                              >
                                {item}
                              </div>
                            ))
                          ) : (
                            <div className="landing-page-suggestions-empty">No suggestions found</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
            </div>
            <button
              className="landing-page-upper-container-field-button"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>

          {/* Interactive Popular Searches */}
          <div className="landing-page-popular-searches">
            <span className="popular-label">Popular Searches:</span>
            {popularSearches[activeTab]?.map((term, idx) => (
              <button
                key={idx}
                className="popular-chip"
                onClick={() => handlePopularSearchClick(term)}
              >
                ⚡ {term}
              </button>
            ))}
          </div>

          {activeTab === "Caselaw" && dropdownValue === "Party Name" && (
            <div className="landing-page-caselaw">
              <div
                onClick={() => setPetitionerTab("Any")}
                className={`landing-page-caselaw-petitioner ${petitionerTab === "Any"
                  ? "landing-page-caselaw-petitioner-active"
                  : ""
                  }`}
              >
                Any
              </div>

              <div
                onClick={() => setPetitionerTab("Petitioner")}
                className={`landing-page-caselaw-petitioner ${petitionerTab === "Petitioner"
                  ? "landing-page-caselaw-petitioner-active"
                  : ""
                  }`}
              >
                Petitioner
              </div>

              <div
                onClick={() => setPetitionerTab("Respondent")}
                className={`landing-page-caselaw-petitioner ${petitionerTab === "Respondent"
                  ? "landing-page-caselaw-petitioner-active"
                  : ""
                  }`}
              >
                Respondent
              </div>
            </div>
          )}
          {activeTab === "Caselaw" && dropdownValue === "Citation" && (
            <Citation onChange={setCitationData} />
          )}
        </div>

        {/* Platform Stats Bar */}
        <div className="landing-page-stats-bar">
          <div className="landing-page-stat-item">
            <span className="stat-number">500k+</span>
            <span className="stat-label">Court Judgments</span>
          </div>
          <div className="landing-page-stat-divider"></div>
          <div className="landing-page-stat-item">
            <span className="stat-number">2,500+</span>
            <span className="stat-label">Central & State Acts</span>
          </div>
          <div className="landing-page-stat-divider"></div>
          <div className="landing-page-stat-item">
            <span className="stat-number">100k+</span>
            <span className="stat-label">Contracts & Clauses</span>
          </div>
          <div className="landing-page-stat-divider"></div>
          <div className="landing-page-stat-item">
            <span className="stat-number">99.9%</span>
            <span className="stat-label">Editorial Precision</span>
          </div>
        </div>
      </div>
      {/* Lower Section */}
      <div className="landing-page-lower">
        <div id="landing-page-lower-boxes" className="landing-page-lower-boxes">
          <div
            className="landing-page-lower-boxes-item interactive-card"
            onClick={() => setActiveFeatureModal("databases")}
          >
            <span className="card-icon-wrapper"><img src={dataIcon} alt="Databases" /></span>
            <span className="landing-page-lower-boxes-item-title">Comprehensive Databases</span>
            <span className="landing-page-lower-boxes-item-descritption">Knowledge graphs + editorial curation</span>
            <span className="card-explore-btn">Explore Details →</span>
          </div>

          <div
            className="landing-page-lower-boxes-item interactive-card"
            onClick={() => setActiveFeatureModal("excellence")}
          >
            <span className="card-icon-wrapper"><img src={gradIcon} alt="Excellence" /></span>
            <span className="landing-page-lower-boxes-item-title">Research Excellence</span>
            <span className="landing-page-lower-boxes-item-descritption">Trusted by universities & labs</span>
            <span className="card-explore-btn">Explore Details →</span>
          </div>

          <div
            className="landing-page-lower-boxes-item interactive-card"
            onClick={() => setActiveFeatureModal("partnerships")}
          >
            <span className="card-icon-wrapper"><img src={partnerIcon} alt="Partnerships" /></span>
            <span className="landing-page-lower-boxes-item-title">Institutional Partnerships</span>
            <span className="landing-page-lower-boxes-item-descritption">Collabs with think tanks</span>
            <span className="card-explore-btn">Explore Details →</span>
          </div>

          <div
            className="landing-page-lower-boxes-item interactive-card"
            onClick={() => setActiveFeatureModal("digests")}
          >
            <span className="card-icon-wrapper"><img src={editorialIcon} alt="Digests" /></span>
            <span className="landing-page-lower-boxes-item-title">Editorial Digests</span>
            <span className="landing-page-lower-boxes-item-descritption">Concise headnotes, same-day updates</span>
            <span className="card-explore-btn">Explore Details →</span>
          </div>
        </div>

        <div className="landing-page-lower-separator"></div>
        <div className="landing-page-lower-bottom">
          <div className="landing-page-lower-bottom-left">
            <div className="landing-page-lower-bottom-left-title">
              India Law Online
            </div>
            <div className="landing-page-lower-bottom-left-description">
              Empowering legal research through technology and AI-powered
              analytics
            </div>
          </div>

          <div className="landing-page-lower-bottom-right">
            <div className="landing-page-lower-bottom-right-item">
              <div className="landing-page-lower-bottom-right-item-title">
                For Institutions
              </div>
              <div className="landing-page-lower-bottom-right-item-description">
                <span>University Partnerships</span>
                <span>Research Support</span>
                <span>Training & Workshops</span>
                <span>AI Models</span>
              </div>
            </div>

            <div className="landing-page-lower-bottom-right-item">
              <div className="landing-page-lower-bottom-right-item-title">
                Support
              </div>
              <div className="landing-page-lower-bottom-right-item-description">
                <span>Help Center</span>
                <span>Documentation</span>
              </div>
            </div>

            <div className="landing-page-lower-bottom-right-item">
              <div className="landing-page-lower-bottom-right-item-title">
                Miscellaneous
              </div>
              <div className="landing-page-lower-bottom-right-item-misc">
                <div className="landing-page-lower-bottom-right-item-description">
                  <span>About Us</span>
                  <span onClick={() => navigate("/pricing")} style={{ cursor: "pointer" }}>
                    Plans
                  </span>
                  <span>Contact Us</span>
                </div>
                <div className="landing-page-lower-bottom-right-item-description">
                  <span>Privacy Policy</span>
                  <span>Terms of Service</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Details Interactive Modal */}
      {activeFeatureModal && featureDetails[activeFeatureModal] && (
        <div className="landing-page-feature-modal-backdrop" onClick={() => setActiveFeatureModal(null)}>
          <div className="landing-page-feature-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="feature-modal-close" onClick={() => setActiveFeatureModal(null)}>×</button>
            <div className="feature-modal-header">
              <div className="feature-modal-icon-container">
                <img src={featureDetails[activeFeatureModal].icon} alt="Icon" className="feature-modal-icon" />
              </div>
              <div>
                <h3>{featureDetails[activeFeatureModal].title}</h3>
                <p className="feature-modal-subtitle">{featureDetails[activeFeatureModal].subtitle}</p>
              </div>
            </div>
            <p className="feature-modal-description">{featureDetails[activeFeatureModal].details}</p>
            <div className="feature-modal-highlights">
              {featureDetails[activeFeatureModal].highlights.map((h, i) => (
                <div key={i} className="highlight-pill">✓ {h}</div>
              ))}
            </div>
          </div>
        </div>
      )}

      {showLoginPopup && (
        <div className="landing-page-login-popup-container">
          <div className="landing-page-login-popup-content">
            <div className="landing-page-popup-left">
              <div className="landing-page-popup-icon">!</div>
              <span>Please login first</span>
            </div>

            <div className="landing-page-popup-close" onClick={() => setShowLoginPopup(false)}>×</div>
          </div>

          {/* bottom progress / running line */}
          <div
            className="landing-page-popup-progress"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
}

export default LandingPage;